import React, { Component, Fragment } from "react";
import Async from "react-select";
import modalIcon from "../../../assets/images/testIcon.svg";
import cloth from "../../../assets/images/testIcon.svg";
import Field from "../../Common/Field/Field";
import ModuleHeader from "../ModuleHeader";
import FileUpload from "../../FileUpload/FileUpload";
import Button from "../../Buttons/Button";

export default class QcModule extends Component {
  state = {
    _id: "",
    qc: [],
    STATUS: [],
    assignedToList: [],
    disabled: false
  };

  componentWillMount() {
    const { _id, qc, qcProcess, STATUS, assignedToList, disabled } = this.props;
    this.setState({
      _id,
      qc,
      qcProcess,
      STATUS,
      assignedToList,
      disabled
    });
  }

  componentWillReceiveProps(nextProps) {
    const { _id, qc, qcProcess, STATUS, assignedToList, disabled } = nextProps;
    this.setState({
      _id,
      qc,
      qcProcess,
      STATUS,
      assignedToList,
      disabled
    });
  }

  render() {
    const { qc, STATUS, assignedToList } = this.state;
    const { permissions } = this.props;
    return (
      <div
        class="card-filter meeting-min-con"
        id="qc"
        style={{ marginBottom: ".5%" }}
      >
        <div class="col-md-12">
          <ModuleHeader
            header={"Grading "}
            onClick={this.onOpenModal}
            _id={this.state._id}
            process={this.state.qcProcess}
            updateModulesMain={this.props.updateModulesMain}
            moduleName={"qc"}
            disabled={this.state.disabled}
            statusList={STATUS}
          />
          <div class="col-md-12 product-form" style={{ paddingBottom: "1%" }}>
            <div class="wash-container">
              <div class="col-md-12 no-padding">
                <div class="col-md-12 no-padding">
                  {/* <div class="col-md-2 step-one">
                    <div class="form-group">
                      <label for="ref-no">Assigned To</label>
                      <br />
                        <div class="custom-async-select">
                          <Async
                              name="assignedTo"
                              value={qc.assignedTo}
                              // onInputChange={this.getFabricNumber}
                              // onChange={(value) => this.props.getFabricInfo(value,index)}
                              placeholder="Find AssignedTo"
                              options={this.state.assignedToList}
                              disabled = {true}
                          />
                      </div>
                    </div>
                  </div> */}
                  <div class="col-md-2 step-one pl-0">
                    <div class="form-group">
                      <Field
                        isFormGroup={true}
                        inputType="checkboxToggle"
                        inputName="anyIssue"
                        value={qc.anyIssue}
                        label="Any Issue"
                        onChange={this.props.updateQc}
                        disabled={this.state.disabled}
                      />
                    </div>
                  </div>
                  <div class="col-md-2 step-one pl-0">
                    {qc.anyIssue && (
                      <div class="form-group">
                        <label for="ref-no">if yes, reason</label>
                        <input
                          type="text"
                          class="form-control"
                          name="reason"
                          value={qc.reason}
                          onChange={e =>
                            this.props.updateQc(e.target.name, e.target.value)
                          }
                        />
                      </div>
                    )}
                  </div>
                  {/* <div class="col-md-2 step-one">
                    <Field
                        isFormGroup={true}
                        inputType="select"
                        inputName="status"
                        value={qc.status}
                        options={STATUS}
                        index ={index}
                        label ={"Status"}
                        onChange={this.props.updateQc}
                        disabled={this.state.disabled}
                      />
                  </div>
                  <div class="col-md-2 step-one pl-0">
                    <Field
                        isFormGroup={true}
                        inputType="date"
                        inputName="completedDate"
                        value={qc.completedDate}
                        label = {"Date completed"}
                        index ={index}
                        onChange={this.props.updateQc}
                        disabled={this.state.disabled}
                      />
                  </div>*/}
                </div>
              </div>

              <div class="col-md-12 hide-customer-site">
                <FileUpload
                  Heading="Upload Images"
                  moduleName={"marker"}
                  getRefImages={refImages =>
                    this.props.getRefImages(refImages, "qc")
                  }
                  disabled={this.state.disabled}
                  uploadedDocs={qc.refImages.length > 0 ? qc.refImages : null}
                  imageTypeOption={[]}
                />
              </div>
              <div class="col-md-12 step-one">
                <Field
                  isFormGroup={true}
                  inputType="textarea"
                  inputName="comments"
                  value={qc.comments}
                  label="comments"
                  onChange={this.props.updateQc}
                  disabled={this.state.disabled}
                />
              </div>
            </div>
            {!this.state.disabled && (permissions.create || permissions.edit) && (
              <div class="col-md-12 no-padding text-center profile-btn">
                <Button
                  buttonName={"save"}
                  onClick={e => this.props.createQC(e)}
                />
                <Button
                  buttonName={"Complete"}
                  onClick={e => this.props.completeQC(e)}
                />
              </div>
            )}
          </div>
          {/* )} */}
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/SampleRequest/QcModule/index.js